import React, { useContext, useEffect } from "react";
import { AppContext } from "../States/AppContext";

// components
import { AlarmHr, AlarmPause, AlarmXTachy } from "./Alarms/Alarms";

//styles
import {
  MessageBoxContainer,
  MessageBoxTop,
  RebootAlert,
} from "./MessageBox.elements";

const MessageBox = ({ landscape }) => {
  const { state, setState } = useContext(AppContext);

  useEffect(() => {
    if (state.startInitiateAlarms === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          hrAlarmAlert: true,
          startInitiateAlarms: false,
        }));
      }, 0);

      return () => clearTimeout(timeoutId);
    }
  }, [state.startInitiateAlarms]);

  useEffect(() => {
    if (state.hrAlarmAlert === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          hrAlarmAlert: false,
          xTachyAlarmAlert: true,
        }));
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [state.hrAlarmAlert]);

  useEffect(() => {
    if (state.alarmsPause === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          hrAlarmAlert: false,
          xTachyAlarmAlert: false,
        }));
      }, 0);

      return () => clearTimeout(timeoutId);
    }
  }, [state.alarmsPause]);

  return (
    <>
      <MessageBoxContainer>
        <MessageBoxTop>
          {state.hrAlarmAlert && <AlarmHr landscape={landscape} />}

          {state.alarmsPause && <AlarmPause landscape={landscape} />}

          {state.xTachyAlarmAlert && <AlarmXTachy landscape={landscape} />}
        </MessageBoxTop>
        <MessageBoxTop>
          {!state.piicConnected && (
            <RebootAlert landscape={landscape}>No Central Monit.</RebootAlert>
          )}
        </MessageBoxTop>
      </MessageBoxContainer>
    </>
  );
};

export default MessageBox;
